import { Dispatch } from 'redux';
import actions from './actionTypes';
import {
  getAuth,
  logOut,
  fetchMinimalWishlist,
  logOutAll,
  getUserHash,
  getUserDetails,
  getPriveTier,
} from './service';
import { saveCartQtyLocalStorage } from 'helpers/listingPage';
import {
  addWishListedItemInStorage,
  removeWishListedItemInStorage,
  updateCartCountInStorage,
  loadVerloop,
  googleLoginTracking,
  updateWishlistItemsInStorage,
} from './helper';

export const fetchAuth = () => (dispatch: Dispatch) => {
  dispatch({
    type: actions.FETCH_AUTH_DATA_PROGRESS,
  });

  return getAuth()
    .then((authData) => {
      dispatch({
        type: actions.FETCH_AUTH_DATA_SUCCESS,
        payload: authData,
      });
      googleLoginTracking();
    })
    .catch((err) => {
      dispatch({
        type: actions.FETCH_AUTH_DATA_FAILED,
      });
      return Promise.reject(err);
    });
};

export const setAuthCartCount = (itemCount = 0) => {
  updateCartCountInStorage(itemCount);
  return {
    type: actions.AUTH_CART_COUNT,
    payload: itemCount || 0,
  };
};

/* Persists per-product cart qty, updates auth storage total, and syncs Redux */
export const updateCartProductQuantities = (
  productQuantities: Record<string, number>
) => {
  const quantities = productQuantities || {};
  saveCartQtyLocalStorage(quantities);
  const total = Object.values(quantities).reduce((a, b) => a + b, 0);
  updateCartCountInStorage(total);
  return {
    type: actions.AUTH_CART_PRODUCT_QTY_UPDATE,
    payload: quantities,
  };
};

export const setIocValue = (iocValue: number) => ({
  type: actions.SET_IOC_VALUE,
  payload: iocValue,
});

export const addToAuthWishlist = (productId = '') => {
  addWishListedItemInStorage(productId);
  return {
    type: actions.AUTH_WISHLIST_ADD,
    payload: productId || '',
  };
};

export const removeFromAuthWishlist = (productId = '') => {
  removeWishListedItemInStorage(productId);
  return {
    type: actions.AUTH_WISHLIST_REMOVE,
    payload: productId || '',
  };
};

export const updateWishlistIds = (wishlistIds: string[]) => {
  updateWishlistItemsInStorage(wishlistIds);
  return {
    type: actions.WISHLIST_IDS_UPDATE,
    payload: wishlistIds || [],
  };
};

export const doLogOut = () => (dispatch: Dispatch) =>
  logOut()
    .then(() => {
      dispatch({
        type: actions.LOGOUT,
      });
    })
    .catch((err) => {
      // * No Action dispatch needed here, so just throwing up the error as the component can handle the failure.
      throw err;
    });

export const getMinimalWishlist = () => async (dispatch: Dispatch) => {
  // FIXME: type for dispatch
  dispatch({
    type: actions.FETCH_AUTH_DATA_PROGRESS,
  });

  try {
    const wishlistProducts = (await fetchMinimalWishlist()) || [];

    dispatch({
      type: actions.WISHLIST_ITEMS_SUCCESS,
      payload: wishlistProducts,
    });
  } catch (err) {
    // ! NO ACTION NECESSARY AS PER SERVICE LOGIC AND THIS LOGIC NEEDS NO VISUAL FEEDBACK
  }
};

export const logoutFromAllSession = () => (dispatch: Dispatch) =>
  logOutAll()
    .then(() => {
      dispatch({
        type: actions.LOGOUT_ALL,
      });
    })
    .catch((err) => {
      // * No Action dispatch needed here, so just throwing up the error as the component can handle the failure.
      throw err;
    });

export const fetchUserHash = () => () =>
  getUserHash()
    .then((data) => {
      loadVerloop(data);
    })
    .catch((err) => {
      loadVerloop();
      return Promise.reject(err);
    });

export const fetchUserDetails = () => (dispatch: Dispatch) =>
  getUserDetails()
    .then((userData: any) => {
      dispatch({
        type: actions.USER_DETAILS_FETCHED,
        payload: userData,
      });
    })
    .catch((err) => {
      dispatch({
        type: actions.USER_DETAILS_FAILED,
      });
      return Promise.reject(err);
    });

export const fetchPriveTier = () => () =>
  getPriveTier()
    .then((tierName) => tierName)
    .catch((err) => Promise.reject(err));
